import React, { FC } from "react";
import { useForm, Controller } from "react-hook-form";
import { ProvidePatientTreatmentProps } from "./types";


const ProvidePatientTreatment: FC<ProvidePatientTreatmentProps> = ({
                                                                       control,
                                                                       watch,
                                                                       setValue,
                                                                       getValues,
                                                                       resetField
                                                                   }): JSX.Element => {
    return (
        <div>
            <div className="d-flex align-items-center gap-3 mb-3">
                <strong>Patient Training Required?</strong>
                <Controller
                    name="prescription_attributes.Patient_training_required"
                    control={control}
                    defaultValue={true}
                    render={({field}) => (
                        <label className="d-flex align-items-center gap-1 mb-0">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={field.value ?? true}
                                onChange={(e) => field.onChange(e.target.checked)}
                                //disabled
                            />
                            Yes
                        </label>
                    )}
                />
            </div>

            <p>
                <strong>Target Glucose Range</strong>{" "}
                <Controller
                    name="prescription_attributes.targetAfterMealBloodGlucoseMin"
                    control={control}
                    defaultValue="70"
                    render={({field}) => (
                        <input
                            {...field}
                            type="text"
                            className="small-input form-control d-inline-block mb-2"
                            style={{maxWidth: '200px'}}
                        />
                    )}
                />{" "}
                to{" "}
                <Controller
                    name="prescription_attributes.targetAfterMealBloodGlucoseMax"
                    control={control}
                    defaultValue="180"
                    render={({field}) => (
                        <input
                            {...field}
                            type="text"
                            className="small-input form-control d-inline-block mb-2"
                            style={{maxWidth: '200px'}}
                        />
                    )}
                />{" "}
                mg/dL{" "}
                <strong>1–2 hours after the start of the meal</strong>
                <sup className="fs-5 top-0">*</sup>
            </p>

            <ul>
                <li>
                    The American Diabetes Association suggests assessing post-meal blood glucose 1–2 hours after the start of a meal.
                </li>
                <li>
                    Continue adjusting dose every <strong>3–4 days</strong>, or{" "}
                    <strong>twice weekly</strong>, if blood glucose is below or above
                    target, until after-meal blood glucose is consistently within your
                    target range up to the maximum daily dose.
                </li>
                <li>
                    The American Diabetes Association suggests insulin
                    regimens be adjusted every 3–4 days until self-monitored blood glucose
                    targets are reached.
                </li>
                <li>
                    To opt out of Patient Training, please contact{" "}
                    <strong>MannKind Cares at 1-844-323-7399</strong>.
                </li>
            </ul>

            {/*<p className="mb-2">*/}
            {/*    <sup className="fs-5 top-0">*</sup>The American Diabetes Association suggests assessing*/}
            {/*    post-meal blood glucose 1–2 hours after the start of a meal.*/}
            {/*</p>*/}

            {/*<p className="mb-2">*/}
            {/*    Continue adjusting dose every <strong>3–4 days</strong>, or{" "}*/}
            {/*    <strong>twice weekly</strong>, if blood glucose is below or above*/}
            {/*    target, until after-meal blood glucose is consistently within your*/}
            {/*    target range up to the maximum daily dose.<sup className="fs-5 top-0">*</sup>*/}
            {/*</p>*/}

            {/*<p className="mb-2">*/}
            {/*    <sup className="fs-5 top-0">*</sup>The American Diabetes Association suggests insulin*/}
            {/*    regimens be adjusted every 3–4 days until self-monitored blood glucose*/}
            {/*    targets are reached.*/}
            {/*</p>*/}

            {/*<p className="mb-2">*/}
            {/*    <sup className="fs-5 top-0">**</sup>To opt out of Patient Training, please contact{" "}*/}
            {/*    <strong>MannKind Cares at 1-844-323-7399</strong>.*/}
            {/*</p>*/}

        </div>

    );
};

export default ProvidePatientTreatment;
